// src/App.js
import React, { useContext } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeContext } from "./contexts/ThemeContext";
import "./App.css";
import UserRoutes from "./Routes/UserRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const { theme } = useContext(ThemeContext);
  return (
    <MuiThemeProvider theme={theme}>
      <>
        <ToastContainer theme="colored" />
        <UserRoutes />
      </>
    </MuiThemeProvider>
  );
}

export default App;
